import React, { useEffect, useRef, useState } from "react";
import uiConfig from "../../config/uiConfig";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
} from "@mui/material";


import TicketForm from "./TicketForm";




function TicketDialog({

  open,

  ticket,

  onClose,

  onSave,

  isSaving

}) {


  const formRef = useRef();

  const [isFormValid, setIsFormValid] = useState(false);

  useEffect(() => {
    console.log("[TicketDialog] isFormValid:", isFormValid, "isSaving:", isSaving);
  }, [isFormValid, isSaving]);




  const handleSubmit = () => {

    formRef.current();

  };



return (


<Dialog

open={open}

onClose={()=>{
if(!isSaving){
onClose();
}
}}

disableEscapeKeyDown={isSaving}

maxWidth="md"

fullWidth

PaperProps={{

sx:{

borderRadius:3,

overflow:"hidden"

}

}}

>


<DialogTitle

sx={{

px:3,

pt:2.5,

pb:1.5

}}

>

<Box>


<Typography
sx={{
fontSize:"24px",
fontWeight:700,
color:"text.primary",
lineHeight:1.2
}}
>

{

ticket

?

"Update Ticket"

:

"Create Ticket"

}

</Typography>


<Typography
sx={{
fontSize:13,
color:"text.secondary",
mt:0.6
}}
>
Capture ticket details with category, priority, assignment, and project mapping.
</Typography>


</Box>


</DialogTitle>







<DialogContent

sx={{

px:3,

py:2.5,

borderColor:"#e2e8f0"

}}

dividers

>


<Box>


<TicketForm

defaultValues={ticket}

onSubmit={onSave}

submitRef={formRef}

onValidityChange={setIsFormValid}


/>


</Box>



</DialogContent>







<DialogActions

sx={{

px:3,


py:2,

gap:1.5,

borderTop:"1px solid",

borderColor:"divider"

}}

>



<Button

variant="outlined"

onClick={onClose}

disabled={isSaving}

sx={{

textTransform:"none",

borderRadius:2

}}

>

Cancel

</Button>







<Button

variant="contained"

onClick={handleSubmit}

disabled={isSaving || !isFormValid}

startIcon={isSaving ? <CircularProgress size={16} color="inherit" /> : null}

sx={{

background:uiConfig.buttonColor,

textTransform:"none",

borderRadius:2,

px:3,

boxShadow:"none",

"&:hover":{
background:"#1d4ed8",
boxShadow:"none"
}

}}

>

{
isSaving
? (ticket ? "Updating..." : "Creating...")
: (ticket ? "Update Ticket" : "Create Task")
}

</Button>





</DialogActions>





</Dialog>


);


}


export default TicketDialog;